import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { authAPI } from '@/api/new-api'

export interface GetVisitorParkingQrRequest {
  buildingId: number
}

export const getVisitorParkingQrQueryKey = (data: GetVisitorParkingQrRequest) => [
  'useGetVisitorParkingQR',
  data,
]

export const getVisitorParkingQR = async (data: GetVisitorParkingQrRequest) => {
  const response = await authAPI.get<Blob>(`/visitor-parking/get-qr`, {
    params: data,
    responseType: 'blob',
  })
  return response.data
}

export const useGetVisitorParkingQR = (data: GetVisitorParkingQrRequest) => {
  const queryResult = useQuery({
    queryFn: () => getVisitorParkingQR(data),
    queryKey: getVisitorParkingQrQueryKey(data),
    select: (blob) => URL.createObjectURL(blob),
  })

  // NOTE: clean up the URL object (created by `select`) when `useGetVisitorParkingQR` unmounts
  useEffect(() => {
    return () => {
      if (queryResult.data) {
        URL.revokeObjectURL(queryResult.data)
      }
    }
  }, [queryResult.data])

  return queryResult
}
